import ThreadsClient, { getPortalApiBase } from '@korvo/portal-sdk/threads-client';

export { getPortalApiBase,ThreadsClient };

